// extracted by css-extract-rspack-plugin
module.exports =  {"root":"ClientUserManagement__root____nE7M"};